import Airtable from "airtable";

const AIRTABLE_API_URL = 'https://api.airtable.com';

Airtable.configure({
  endpointUrl: AIRTABLE_API_URL,
  apiKey: process.env.REACT_APP_AIRTABLE_API_KEY
});
export const airtableBase = Airtable.base('apprIJ6nEcJuS1Y4h');